import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import * as ProductionOrderSapService from "../../../../services/ProductionOrderSapService";
import { useTranslation } from "react-i18next";
import ProductionOrderSapExtraInforForm from "./productionOrderSapExtraInfoForm.view";
import ShowDialog from "../../../utils/ShowDialog/ShowDialog";

const ExtraInfoPOSAPFormContainer = ({ uuid, data, onCancel, onSuccess }) => {
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [order, setOrder] = useState({});

  const setInitialValues = useCallback(async (dataExtrainfo) => {
    setInitValues(dataExtrainfo);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await ProductionOrderSapService.getDetail(uuid);
      setOrder(result.data);
      if (result.data.extraInfo) {
        setInitialValues(result.data.extraInfo);
      }
    }
    if (data) {
      setOrder(data.data);
      setInitialValues(data.data.extraInfo);
    }
  }, [setInitialValues, uuid, data]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleSave = async (values) => {
    try {
      if (order && values) {
        const result =
          await ProductionOrderSapService.addExtraInfoProductionOrderSap(
            order.uuid,
            values
          );

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.productionOrderSap.messages.update.saveTitle");
          text = t("forms.productionOrderSap.messages.update.saveSuccess");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.productionOrderSap.messages.update.saveError");
          icon = "error";
        }

        let okAction = () => {
          if (onSuccess) {
            onSuccess();
          }
        };
        ShowDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (order && values) {
        const result =
          await ProductionOrderSapService.addExtraInfoAndFinishProductionOrderSap(
            order.uuid,
            values
          );

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.productionOrderSap.messages.update.finishTitle");
          text = t("forms.productionOrderSap.messages.update.finishSuccess");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.productionOrderSap.messages.update.finishError");
          icon = "error";
        }

        let okAction = () => {
          if (onSuccess) {
            onSuccess();
          }
        };
        ShowDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  return (
    <ProductionOrderSapExtraInforForm
      initialValues={initValues}
      onSubmit={handleSubmit}
      onSave={handleSave}
      onBack={onCancel}
    />
  );
};

ExtraInfoPOSAPFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ExtraInfoPOSAPFormContainer;
